import React from 'react';
import CollectionImageProp from './properties/collection-image';

function CollectionImage({ collection }: CollectionImageProp):React.ReactElement {
  const collectionHref = `/collection?id=${collection.collectionId}`;
  const imageUrl = collection?.imageUrl ? collection?.imageUrl : collection?.image;
  return (
    <div className="col-sm-6 col-md-4 col-lg-3 text-center collection-image-box">
      <a href={collectionHref} className="rounded box">
        <img
          alt="EDS NFT"
          src={imageUrl}
          className="rounded-circle image-fill-small"
        />
        <h6>{collection.name}</h6>
      </a>
    </div>
  );
}

export default CollectionImage;
